const defaultGroupSeperator = '&';
const defaultPairSeperator = '=';
/**
 * @example
 * ```typescript
 * const parser = new KVParser({
 *   groupSeperator: '&',
 *   pairSeperator: '=',
 *   canSkipEmpty: true,
 *   needDecode: true,
 * });
 * const params = parser.parse(location.query);
 * ```
 */

export default class KVParser {
  /**
   *
   * @param options
   * @param options.groupSeperator 键值组分割符，比如a=1&b=2中的&
   * @param options.pairSeperator 键值对分割符，比如a=1&b=2中的=
   * @param options.canSkipEmpty 是否过滤值为空的键值对
   * @param options.needDecode 是否对值进行解码
   */
  constructor({
    groupSeperator = defaultGroupSeperator,
    pairSeperator = defaultPairSeperator,
    canSkipEmpty = false,
    needDecode = true
  } = {}) {
    this.groupSeperator = groupSeperator instanceof RegExp ? groupSeperator.source : groupSeperator;
    this.pairSeperator = pairSeperator instanceof RegExp ? pairSeperator.source : pairSeperator;
    this.canSkipEmpty = canSkipEmpty;
    this.needDecode = needDecode;
  }

  parse(content) {
    if (typeof content !== 'string' || content === '') {
      return {};
    }

    const regexp = this.createPattern();
    const params = {};
    let matches;

    while (matches = regexp.exec(content)) {
      const [, k,, v] = matches;
      const isEmpty = v === null || v === undefined || v === '';

      if (this.canSkipEmpty && isEmpty) {
        continue;
      }

      if (isEmpty) {
        params[k] = '';
      } else {
        params[k] = this.needDecode ? decodeURIComponent(v) : v;
      }
    }

    return params;
  }

  createPattern() {
    return new RegExp(`([^(${this.groupSeperator})(${this.pairSeperator})]+)(${this.pairSeperator}([^(${this.groupSeperator})(${this.pairSeperator})]*))?`, 'g');
  }

}